import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { planSelectorWithMI } from 'features/billing/selectors'

export const fetchUpcomingInvoice = createAsyncThunk(
  'upcomingInvoice/fetch',
  async (params, { rejectWithValue, getState }) => {
    const currentTier = planSelectorWithMI(getState())

    const estimationParams = { ...params }

    if (currentTier === 'standard_all' && params.tier_id === 'teams') {
      estimationParams.replace_addon_list = true
    }

    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/invoices/new',
      method: 'GET',
      params: estimationParams
    })

    if (!success) {
      return rejectWithValue({
        isMinimumSeatError: response && response.payload && response.payload.key === 'billing.quantity.seat_minimum',
        isMaximumSeatError: response && response.payload && response.payload.key === 'billing.quantity.seat_maximum',
        errorMessage: response.message
      })
    }

    return response
  }
)
